import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../context/theme-context';
import { useContext } from 'react';
import './charts.scss';

/**
 * Hata durumunda yeniden yükleme butonu içeren hata bileşeni
 * @param {Object} props - Bileşen özellikleri
 * @param {function} props.onReload - Yeniden yükleme fonksiyonu
 * @param {string} props.height - Bileşenin yüksekliği (örn: '300px')
 * @param {string} props.errorMessage - Özel hata mesajı (isteğe bağlı)
 */
const ErrorWithReload = ({ onReload, height = '300px', errorMessage = null }) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  
  return (
    <div className="chart-error-container" style={{ height }}>
      <div className="chart-error-content">
        <div className="chart-error-message">
          {errorMessage || t('componentErrors.dataLoadFailed')}
        </div>
        <div 
          className={`text-reload-button ${theme}`}
          onClick={onReload}
        >
          {t('componentErrors.reload')}
        </div>
      </div>
    </div>
  );
};

export default ErrorWithReload;
